import { Component, OnInit, Input } from '@angular/core';
import { faThemeisle } from '@fortawesome/free-brands-svg-icons';

const circleProgress = {
  radius: {
    normal: 80,
    pequeno: 51,
  },
  outerStrokeWidth: {
    normal: 10,
    pequeno: 7,
  },
  innerStrokeWidth: {
    normal: 5,
    pequeno: 4,
  },
  content: {
    normal: 'content--normal',
    pequeno: 'content--pequeno',
  },
};

@Component({
  selector: 'lovers-circular-progress-bar',
  templateUrl: './circular-progress-bar.component.html',
  styleUrls: ['./circular-progress-bar.component.scss'],
})
export class CircularProgressBarComponent implements OnInit {
  @Input() legenda: string = '';
  @Input() exibirValorAtual: boolean = false;
  @Input() valorAtual: number = 0;
  @Input() exibirValorTotal: boolean = false;
  @Input() valorTotal: number = 0;
  @Input() exibirSeparador: boolean = false;
  @Input() porcentagem: number = undefined;
  @Input() unidadeMedida: string = '';
  @Input() cor: string = '#FF5C3E';
  @Input() corGradiante: string = '';
  @Input() tamanho: string = 'normal';
  @Input() gradiente: boolean = true;
  @Input() exibirFundoPreto: boolean = false;

  public tamanhoFonte: string = 'fonte--normal';

  constructor() {}

  ngOnInit(): void {
    this.tratarDados();
  }

  tratarDados(): void {
    if (this.unidadeMedida !== '%') {
      this.unidadeMedida = ` ${this.unidadeMedida}`;
    }
    if (this.legenda === 'Paquera') this.tamanhoFonte = 'fonte--pequena';
  }

  calcularPorcentagem(): number {
    if (this.porcentagem !== undefined) {
      return this.porcentagem;
    }

    try {
      let porcentagem = (this.valorAtual * 100) / this.valorTotal;
      return porcentagem;
    } catch (ex) {
      console.warn(
        'Não foi possível calcular a porcentagem baseada no valor atual e total',
        ex
      );
    }
    return 0;
  }

  definirStopColor(): string {
    if (this.legenda == 'Crush') {
      this.corGradiante = '#ff9999';
      this.cor = '#ff5c3e';
    } else if (this.legenda == 'Paquera') {
      this.corGradiante = '#ff5c3e';
      this.cor = '#ea2200';
    } else if (this.legenda == 'Paixão') {
      this.corGradiante = '#ea2200';
      this.cor = '#c00000';
    } else if (this.legenda == 'Amor') {
      this.corGradiante = '#c00000';
      this.cor = '#ff9999';
    } else {
      this.cor = '#ff5c3e';
      this.corGradiante = '#ff5c3e';
    }
    // if (this.gradiente) this.cor + '99';
    return this.cor, this.corGradiante;
  }

  definirTamanho(campo) {
    return circleProgress[campo][this.tamanho];
  }

  definirClasse(): string {
    let classe = '';

    switch (this.legenda) {
      case 'Crush':
        classe += 'nivel--crush';
        break;
      case 'Paixão':
        classe += 'nivel--paixao';
        break;
      case 'Amor':
        classe += 'nivel--amor';
        break;
      case 'Paquera':
        classe += 'nivel--paquera';
        break;
      case 'Mozão':
        classe += 'nivel--mozao';
        break;
      case 'Embaixador':
          classe += 'nivel--embaixador';
          break;
    }

    return classe;
  }
}
